module.exports = girder_plugin_large_image;


//////////////////
// WEBPACK FOOTER
// external "girder_plugin_large_image"
// module id = 0
// module chunks = 0